import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { MyBookingsContent } from './MyBookingsContent';
import { MyBookingsHeader } from './MyBookingsHeader';
import { MyBookingsFooter } from './MyBookingsFooter';
import { GuestActions } from './GuestActions';
import { Section } from '../../../../content-sections/ui/components/Section';
import { BookingDetailsDialogRoute } from '../details';
import { useMyBookingsStore } from '../../../domain/booking/stores/useMyBookingsStore';
import { AddGuestBookingDialogRoute } from '../guest-booking/AddGuestBookingDialogRoute';
import { ModifyGuestBookingDialogRoute } from '../guest-booking/ModifyGuestBookingDialogRoute';
import { IBooking } from '../../../domain/booking/models/IBooking';
import { AMOUNT_OF_CARDS_TO_SHOW } from '../../../../account/domain/constants';
import ContentWrap from '../../../../../ui/components/Layout/ContentWrap';
import { useIsAuthenticatedAfterHydration } from '../../../../auth/shared/store/useIsAuthenticatedAfterHydration';

interface IMyBookingsProps {
	viewAll?: boolean;
}
export const MyBookings = observer(({ viewAll = false }: IMyBookingsProps) => {
	const [bookings, setBookings] = useState<IBooking[]>([]);
	const isAuthenticated = useIsAuthenticatedAfterHydration();
	const store = useMyBookingsStore();

	useEffect(() => {
		store.load();
	}, []);

	useEffect(() => {
		if (isAuthenticated)
			setBookings(
				viewAll
					? store.bookings
					: store.bookings.slice(0, AMOUNT_OF_CARDS_TO_SHOW),
			);
	}, [isAuthenticated, viewAll, store.bookings]);

	if (!isAuthenticated) {
		return <GuestActions />;
	}

	return (
		<>
			<Section>
				<ContentWrap>
					<MyBookingsHeader
						number={store.bookings.length}
						showViewAll={!!store.bookings.length && !viewAll}
						showRetrieveAsGuest={viewAll}
					/>
					<MyBookingsContent loading={store.isLoading} bookings={bookings} />
					<MyBookingsFooter />
				</ContentWrap>
			</Section>
			<BookingDetailsDialogRoute />
			<AddGuestBookingDialogRoute />
			<ModifyGuestBookingDialogRoute />
		</>
	);
});
